import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Paper,
    Typography,
    Card,
    CardContent
} from '@mui/material';
import {
    Category as CategoryIcon,
    Inventory as InventoryIcon,
    ShoppingBag as ShoppingBagIcon
} from '@mui/icons-material';
import { getCategories, getSubCategories, getProducts } from '../../../services/firestoreService';
import { COLORS } from '../../../assets/colors';

function Dashboard() {
    const [stats, setStats] = useState({
        categories: 0,
        subCategories: 0,
        products: 0
    });

    useEffect(() => {
        loadStats();
    }, []);

    const loadStats = async () => {
        console.log('🔄 Cargando estadísticas...');
        const [categoriesRes, subCategoriesRes, productsRes] = await Promise.all([
            getCategories(),
            getSubCategories(),
            getProducts()
        ]);

        console.log('📊 Resultados:', {
            categories: categoriesRes,
            subCategories: subCategoriesRes,
            products: productsRes
        });

        setStats({
            categories: categoriesRes.data?.length || 0,
            subCategories: subCategoriesRes.data?.length || 0,
            products: productsRes.data?.length || 0
        });
    };

    const StatCard = ({ title, value, icon, color }) => (
        <Card sx={{
            background: `linear-gradient(135deg, ${color} 0%, ${color}dd 100%)`,
            color: 'white',
            boxShadow: `0 4px 12px ${color}40`,
            transition: 'transform 0.3s ease',
            '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: `0 8px 24px ${color}60`
            }
        }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                        <Typography variant="h6" sx={{
                            fontFamily: 'Quicksand',
                            fontWeight: 600,
                            marginBottom: 1,
                            opacity: 0.9
                        }}>
                            {title}
                        </Typography>
                        <Typography variant="h3" sx={{
                            fontFamily: 'Quicksand',
                            fontWeight: 'bold'
                        }}>
                            {value}
                        </Typography>
                    </Box>
                    <Box sx={{
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        borderRadius: '50%',
                        padding: 2,
                        display: 'flex'
                    }}>
                        {icon}
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );

    return (
        <Box>
            <Typography variant="h4" sx={{
                fontFamily: 'Quicksand',
                fontWeight: 'bold',
                color: COLORS.primary,
                marginBottom: 4
            }}>
                Dashboard
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                    <StatCard
                        title="Categorías"
                        value={stats.categories}
                        icon={<CategoryIcon sx={{ fontSize: 40 }} />}
                        color={COLORS.primary}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <StatCard
                        title="Subcategorías"
                        value={stats.subCategories}
                        icon={<InventoryIcon sx={{ fontSize: 40 }} />}
                        color={COLORS.secondary}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <StatCard
                        title="Productos"
                        value={stats.products}
                        icon={<ShoppingBagIcon sx={{ fontSize: 40 }} />}
                        color="#17a2b8"
                    />
                </Grid>
            </Grid>

            <Paper sx={{
                padding: 3,
                marginTop: 4,
                borderRadius: 2
            }}>
                <Typography variant="h5" sx={{
                    fontFamily: 'Quicksand',
                    fontWeight: 'bold',
                    color: COLORS.primary,
                    marginBottom: 2
                }}>
                    Bienvenido al Panel de Administración
                </Typography>
                <Typography sx={{
                    fontFamily: 'Quicksand',
                    color: '#666',
                    lineHeight: 1.8
                }}>
                    Desde aquí puedes gestionar todas las categorías, subcategorías y productos de la panadería El Rosal.
                    Utiliza el menú lateral para navegar entre las diferentes secciones.
                </Typography>
            </Paper>
        </Box>
    );
}

export default Dashboard;
